import { componentStyle } from '@/styling/util/component-style.ts';
import type { ChipDesignTokens } from '@primeuix/themes/types/chip';

export const chipStyle = componentStyle<ChipDesignTokens>({
    root: {
        paddingY: '0.25rem',
    },
});
